
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://woydvhczdsaehgccyqvp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndveWR2aGN6ZHNhZWhnY2N5cXZwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAyODYxMDMsImV4cCI6MjA0NTg2MjEwM30.VeU72KHoe2nXOeoqfPWfrrlLMvFmseZMQJmXTMNGqoU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // Activer cette option pour détecter les redirections OAuth
    flowType: 'implicit'
  }
});

// Helper function for debugging
export const checkSession = async () => {
  const { data, error } = await supabase.auth.getSession();
  console.log("Current session:", data?.session, "Error:", error);
  return data?.session;
};

// Fonction utilitaire pour nettoyer le stockage local si besoin
export const clearAuthStorage = () => {
  localStorage.removeItem('supabase.auth.token');
  localStorage.removeItem('sb-woydvhczdsaehgccyqvp-auth-token');
  console.log("Auth storage cleared");
};
